import { useLocalSearchParams, useRouter } from 'expo-router';

export default function BranchIndexPage() {
  const { branch } = useLocalSearchParams();
  const router = useRouter();

  branch && router.replace(`/${branch}/campaign/`);

  return null;
} 